<template>
  <div class="users-container">
    <!-- Tab Navigation -->
    <div class="users-tabs">
      <router-link 
        :to="{ name: 'users-list' }" 
        class="users-tab"
        :class="{ active: isAdminUsersActive }"
      >
        <vue-feather type="shield" size="16" />
        Admin Users
      </router-link>
      <router-link 
        :to="{ name: 'app-users-list' }" 
        class="users-tab"
        :class="{ active: isAppUsersActive }"
      >
        <vue-feather type="users" size="16" />
        App Users
      </router-link>
    </div>
    
    <router-view />
  </div>
</template>

<script>
import { computed } from 'vue'
import { useRoute } from 'vue-router'

export default {
  name: 'UsersIndex',
  setup() {
    const route = useRoute()
    
    const isAdminUsersActive = computed(() => {
      return route.name === 'users-list' || 
             route.name === 'add-user' || 
             route.name === 'edit-user' ||
             route.name === 'roles-permissions'
    })
    
    const isAppUsersActive = computed(() => {
      return route.name === 'app-users-list'
    })
    
    return {
      isAdminUsersActive,
      isAppUsersActive
    }
  }
}
</script>

<style scoped>
.users-container {
  display: flex;
  flex-direction: column;
}

.users-tabs {
  display: flex;
  gap: 0.5rem;
  padding: 0 1.5rem;
  margin-bottom: 1rem;
  border-bottom: 1px solid #e5e7eb;
}

.users-tab {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: #6b7280;
  text-decoration: none;
  border-bottom: 2px solid transparent;
  margin-bottom: -1px;
  transition: all 0.2s;
}

.users-tab:hover {
  color: #374151;
}

.users-tab.active {
  color: #6366f1;
  border-bottom-color: #6366f1;
}

/* Dark mode */
:global(body.dark-mode) .users-tabs {
  border-color: #374151;
}

:global(body.dark-mode) .users-tab {
  color: #9ca3af;
}

:global(body.dark-mode) .users-tab:hover {
  color: #e5e7eb;
}

:global(body.dark-mode) .users-tab.active {
  color: #818cf8;
  border-bottom-color: #818cf8;
}
</style>
